export default "__VITE_ASSET__11e29871__"